<script>
  export let group;
  export let data;
  export let report = {};

  $: displayUnit = $group?.data.settings.display_unit;
  $: squareFootage = formattedArea(data.totals.block_area || 0, displayUnit);
  $: openingsSf = formattedArea(data.totals.collection_area, displayUnit);
  $: edgeTreatment = formattedLength(data.totals.edge_treatment, displayUnit);
  $: totalWidth = formattedLength(data.totals.total_width, displayUnit);
  $: totalHeight = formattedLength(data.totals.total_height, displayUnit);
  $: perimeter = formattedLength(data.totals.perimeter, displayUnit);

  function formattedArea(area, displayUnit) {
    if (displayUnit === "millimeters") {
      return (area * 0.092903).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });
    } else {
      return area.toFixed(2);
    }
  }

  function formattedLength(length, displayUnit) {
    if (displayUnit === "millimeters") {
      return (length * 25.4).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });
    } else {
      return length.toFixed(2);
    }
  }
</script>

<div class="grow flex gap-2 px-2 flex-wrap group-summary-container">
  {#if report?.show_total_units}
    <div class="datum-block">
      <div class="info-text">{data.totals.units}</div>
      <div class="label-text">Units</div>
    </div>
  {/if}

  {#if $group?.project_type !== "product" && report?.show_total_categories}
    <div class="datum-block">
      {#if report?.group_by === "opening"}
        <!-- <div class="info-text">{data.totals.collection_count}</div> -->
        <div class="info-text">{data.totals.sections_count}</div>
        <div class="label-text">Openings</div>
      {:else}
        <div class="info-text">{data.totals.sections_count}</div>
        <div class="label-text">Types</div>
      {/if}
    </div>
  {/if}

  {#if report?.show_total_area}
    <div class="datum-block">
      <div class="info-text">{squareFootage}</div>
      <div class="label-text">{displayUnit === "millimeters" ? "m²" : "SqFt"}</div>
    </div>
  {/if}

  {#if report?.show_total_collection_area}
    <div class="datum-block">
      <div class="info-text">{openingsSf}</div>
      <div class="label-text">{displayUnit === "millimeters" ? "m²" : "SqFt"} (Openings)</div>
    </div>
  {/if}

  {#if $group?.project_type !== "product" && report?.show_total_edge_treatment}
    <div class="datum-block">
      <div class="info-text">{edgeTreatment}</div>
      <div class="label-text">Edge Treatment ({displayUnit === "millimeters" ? "mm" : "in"})</div>
    </div>
  {/if}

  {#if report?.show_total_width}
    <div class="datum-block">
      <div class="info-text">{totalWidth}</div>
      <div class="label-text">Linear Width ({displayUnit === "millimeters" ? "mm" : "in"})</div>
    </div>
  {/if}

  {#if report?.show_total_height}
    <div class="datum-block">
      <div class="info-text">{totalHeight}</div>
      <div class="label-text">Linear Height ({displayUnit === "millimeters" ? "mm" : "in"})</div>
    </div>
  {/if}

  {#if report?.show_total_perimeter}
    <div class="datum-block">
      <div class="info-text">{perimeter}</div>
      <div class="label-text">Total Perimeter ({displayUnit === "millimeters" ? "mm" : "in"})</div>
    </div>
  {/if}
</div>

<style lang="scss">
  .datum-block {
    @apply flex-1;
  }

  .info-text {
    @apply font-bold text-base;
  }

  .label-text {
    @apply text-xs text-gray-400 truncate;
  }
</style>
